import Vue from 'vue'
import Router from 'vue-router'
import OrganDesigner from '@/components/OrganDesigner'
import OrganViewer from '@/components/OrganViewer'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/admin/:organ?',
      name: 'designer',
      component: OrganDesigner,
      props: (route) => ({ organ: route.path.indexOf('\\') >= 0 ? route.path.replace('/admin', '').split('\\')[0] : route.path.replace('/admin', ''),
        frame: route.path.split('\\')[1] * 1,
        totalFrames: route.path.split('\\')[2] * 1,
        autoSelect: false,
        editable: true })
    },
    {
      path: '/:organ?',
      name: 'viewer',
      component: OrganViewer,
      props: (route) => ({ organ: route.path.replace('/', '').split('\\')[0],
        frame: route.path.split('\\')[1] * 1,
        totalFrames: route.path.split('\\')[2] * 1,
        autoSelect: true,
        editable: false })
    }
  ]
})

// router.replace('designer')
export default router



// WEBPACK FOOTER //
// ./src/router/index.js